<template>
  <generic-container
    v-bind:show_plus="true"
    icon="building"
    :title="$t('movement types')"
    v-on:add="add"
  >
    <table
      class="ui blue celled very compact selectable striped table"
      ref="table"
      style="width:100%"
    >
      <thead>
        <tr>
          <th>{{ $t("name") }}</th>
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(type, index) in movement_types" :key="index">
          <td>{{ type.name }}</td>
          <td>
            <div>
              <div class="ui mini basic right floated button" @click="set_up(type)">
                <i class="settings icon"></i>
                {{ $t("configure") }}
              </div>
              <div class="ui mini basic right floated button" @click="remove(type, index)">
                <i class="red trash icon"></i>
                {{ $t("delete") }}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <template v-for="(mdl, index) in type_modals">
      <component
        :is="mdl"
        :key="index"
        :type_in="selected_type"
        @destroy="destroy"
        @updated="finish"
      ></component>
    </template>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { local_api, stringify } from "@/utils";
import MovementTypeModal from "../movement_type_modal/MovementTypeModalIndex";

export default {
  name: "MovementTypes",
  components: {
    GenericContainer
  },
  props: {},
  data() {
    return {
      movement_types: [],
      type_modals: [],
      selected_type: {}
    };
  },
  methods: {
    add() {
      let vm = this;
      vm.$alertify.prompt(this.$t("enter type name"), "", function(
        element,
        value
      ) {
        local_api(vm, "post", "/account_movement_type/do-create", {
          n: value
        })
          .then(l => {
            vm.movement_types.push(l);
          })
          .catch(err => {
            vm.$alertify.error(stringify(err));
          });
      });
    },
    remove(type, index) {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to remove type?"), function() {
        local_api(vm, "post", "/account_movement_type/do-remove", {
          u: type.uuid
        })
          .then(() => {
            vm.movement_types.splice(index, 1);
          })
          .catch(err => {
            vm.$alertify.error(stringify(err));
          });
      });
    },
    set_up(type) {
      this.selected_type = type;
      this.type_modals.push(MovementTypeModal);
    },
    finish(data) {
      let trgt = this.movement_types.find(n => n.uuid == data.uuid);
      if (trgt) {
        trgt.name = data.name;
        trgt.setup = data.setup;
      }
    },
    destroy() {
      // console.log("destroyed");
      this.type_modals = [];
    }
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/account_movement_type/do-get-list", {})
      .then(movementTypes => {
        vm.movement_types = movementTypes;
      })
      .catch(err => {
        vm.$alertify.error(stringify(err));
      });
  }
};
</script>